import {gql} from 'apollo-angular';
export const SET_STORY_QUIZ_QUESTION_ANSWER = gql`
  query sendStoryQuizQuestionAnswer($gameId: Int!, $questionId: Int!, $answerId: Int!) {
    sendStoryQuizAnswer(gameID: $gameId, questionID: $questionId, answerID: $answerId) {
      correctAnswerId
      status {
        type
        message
      }
    }
  }
`;
